
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class NotifSystem extends NoboxEntityDialog<NotifRow, any> {
        protected getFormKey() { return NotifSystemForm.formKey; }
        protected getIdProperty() { return NotifRow.idProperty; }
        protected getLocalTextPrefix() { return NotifRow.localTextPrefix; }
        protected getNameProperty() { return NotifRow.nameProperty; }
        protected getService() { return NotifService.baseUrl; }
        protected getDeletePermission() { return NotifRow.deletePermission; }
        protected getInsertPermission() { return NotifRow.insertPermission; }
        protected getUpdatePermission() { return NotifRow.updatePermission; }

        protected form = new NotifSystemForm(this.idPrefix);
        constructor(container?: JQuery) {
            super(container);
        }
        dialogClose() {

        }
        protected updateTitle() {
            this.dialogTitle = "Notif System";
        }
        getToolbarButtons() {
            var button = [] as Serenity.ToolButton[];
            button.push({
                title: "Send Notification",
                onClick: () => {
                    if (this.validateForm()) {
                        NotifService.NotifSystem({
                            Entity: this.getSaveEntity()
                        }, (res) => {
                            Q.notifySuccess("Success send notification");
                        })
                    }
                }
            });
            return button;
        }
        //getDialogButtons() {
        //    var button = [] as Serenity.DialogButton[];
        //    button.push({
        //        text: "Send Notification",
                
        //        click: () => {
        //            if (this.validateForm()) {
        //                NotifService.NotifSystem({
        //                    Entity: this.getSaveEntity()
        //                }, (res) => {
        //                    Q.notifySuccess("Success send notification");
        //                })
        //            }
        //        }
        //    });
        //    return button;
        //}
    }
}